(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  var form = document.getElementById("contact-form");

  async function handleSubmit(event) {
    event.preventDefault();
    var status = document.querySelector(".form__message");
    var data = new FormData(event.target);
    fetch(event.target.action, {
      method: form.method,
      body: data,
      headers: {
        'Accept': 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        status.innerHTML =
          `<p class="contact__copy">Thank you for your message. It has been delivered to Blue Star Press.</p>`;
        form.reset()
      } else {
        response.json().then(data => {
          if (Object.hasOwn(data, 'errors')) {
            status.innerHTML = data["errors"].map(error => error["message"]).join(", ")
          } else {
            status.innerHTML = "Oops! There was a problem submitting your form"
          }
        })
      }
    }).catch(error => {
      status.innerHTML = "Oops! There was a problem submitting your form"
    });
  }
  form.addEventListener("submit", handleSubmit)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var element = document.querySelector('.banner-images-list');
    var height = element.getBoundingClientRect().height;
    var secondElement = document.querySelector('.banner--extra-large');
    secondElement.style.height = height + 'px';
    console.log("Height of the banner-images-list:", height);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-brands"] && !Shopify.designMode) return;
  try {
    
    // Selecting elements using querySelector
  const menuListLinks = document.querySelectorAll(".feature-brands__menu-list li a");
  const menuImageHolderImg = document.querySelector(".menu-image-holder img");

  // Adding event listener for mouseover
  menuListLinks.forEach(link => {
    link.addEventListener("mouseover", () => {
      const value = link.getAttribute('data-src');
      menuImageHolderImg.setAttribute("src", value);
    });
  });

  // Adding event listener for mouseout
  // menuListLinks.forEach(link => {
  //   link.addEventListener("mouseout", () => {
  //     menuImageHolderImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0631/2679/8527/files/si-sabo-illustration.png?v=1705364661");
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  document.addEventListener("DOMContentLoaded", function() {
    var triggers = document.querySelectorAll('.footer-block__accordion-trigger');
    var footerAccordionIsMobile = null;

    function toggleAccordion() {
      var shouldUseAccordion = window.innerWidth < 768;

      if (shouldUseAccordion === footerAccordionIsMobile) return;
      footerAccordionIsMobile = shouldUseAccordion;
 
      if (shouldUseAccordion) { 
        triggers.forEach((trigger) => {
          var content = document.getElementById(trigger.getAttribute('aria-controls'));
          var iconPlus = trigger.querySelector('.icon-plus');
          var iconMinus = trigger.querySelector('.icon-minus');

          trigger.setAttribute('aria-expanded', 'false');
          content.style.display = 'none';
          iconPlus.style.display = 'block';
          iconMinus.style.display = 'none';

          trigger.onclick = function() {
            var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            
            // Close all other contents 
            triggers.forEach((otherTrigger) => {
              if (otherTrigger !== trigger) {
                var otherContent = document.getElementById(otherTrigger.getAttribute('aria-controls'));
                var otherIconPlus = otherTrigger.querySelector('.icon-plus');
                var otherIconMinus = otherTrigger.querySelector('.icon-minus');

                otherTrigger.setAttribute('aria-expanded', 'false');
                otherContent.style.display = 'none';
                otherIconPlus.style.display = 'block';
                otherIconMinus.style.display = 'none';
              }
            });

            // Toggle the clicked content
            trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
            content.style.display = isExpanded ? 'none' : 'block';
            

            // Toggle icons
            if (isExpanded) {
                iconPlus.style.display = 'block';
                iconMinus.style.display = 'none';
            } else {
                iconPlus.style.display = 'none';
                iconMinus.style.display = 'block';
            }
          };
        });
      } else {
        triggers.forEach((trigger) => {
            trigger.setAttribute('aria-expanded', 'false');
        });
        // If larger than 768px, ensure all contents are visible
        document.querySelectorAll('.footer-block__details-content').forEach((content) => {
            content.style.display = 'block'; // Always display the content
        });
        // Ensure minus icons are hidden 
        document.querySelectorAll('.footer .icon-plus').forEach(icon => icon.style.display = 'none');
        document.querySelectorAll('.footer .icon-minus').forEach(icon => icon.style.display = 'none');
      }
    }

    toggleAccordion(); // Call on initial load

    window.addEventListener('resize', toggleAccordion); // Call on window resize
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bank"]) return;
  try {
    
    // Modify product format
    let modifyProductFormate = document.querySelector('.press-material-info__product-details p');
    // modifyProductFormate.innerHTML = modifyProductFormate.innerHTML.replace('Page Count:', '<br> Page Count:');
    // modifyProductFormate.innerHTML = modifyProductFormate.innerHTML.replace('Size:', '<br> Size:');
    modifyProductFormate.innerHTML = modifyProductFormate.innerHTML.replace('Format:', '<br> Format:');
    // modifyProductFormate.innerHTML = modifyProductFormate.innerHTML.replace('ISBN:', '<br> ISBN:');
    modifyProductFormate.innerHTML = modifyProductFormate.innerHTML.slice(0, -4);

    // Accordion functionality
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) { acc[i].addEventListener("click", function () { this.classList.toggle("active"); var
        panel=this.nextElementSibling; if (panel.style.maxHeight) { panel.style.maxHeight=null; } else {
        panel.style.maxHeight=panel.scrollHeight + "px" ; } }); }

    // Tab functionality
    document.addEventListener('DOMContentLoaded', () => {
        const tabButtons = document.querySelectorAll('.tab-button');
        const tabContents = document.querySelectorAll('.tab-content');

        // Check URL hash to activate corresponding tab on page load
        const hash = window.location.hash.substring(1);
        if (hash) {
            const targetButton = document.querySelector(`.tab-button[data-tab-target="${hash}"]`);
            if (targetButton) {
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));
                targetButton.classList.add('active');
                document.getElementById(hash).classList.add('active');
            }
            else {
                // If hash doesn't match any tab, default to first tab
                tabButtons[0].classList.add('active');
                tabContents[0].classList.add('active');
            }
        }

        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Remove active class from all buttons and content
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));
                
                // Add active class to clicked button
                button.classList.add('active');
                
                // Show corresponding content
                const targetId = button.dataset.tabTarget;
                document.getElementById(targetId).classList.add('active');

                // Add ID to URL without reloading
                history.pushState(null, '', `#${targetId}`);
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partnership"] && !Shopify.designMode) return;
  try {
    
    new Glider(document.querySelector('.glider'), {
    // Mobile-first defaults
    slidesToShow: 1,
    slidesToScroll: 1,
    scrollLock: false,
    draggable: true,
    rewind: true,
    arrows: {
      prev: '.glider-prev',
      next: '.glider-next'
    },
    responsive: [
      {
        // screens greater than >= 775px
        breakpoint: 775,
        settings: {
          // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 'auto',
          slidesToScroll: 'auto',
          itemWidth: 150,
          duration: 0.25
        }
      },{
        // screens greater than >= 1024px
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          itemWidth: 150,
          duration: 0.25
        }
      }
    ]
  })

  } catch(e) { console.error(e); }
})();
})();
